import React, { useState, useEffect, useRef } from 'react'
import Sadface from '../../assets/images/sad-face.svg'
import { useAuth } from '../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../scss/style/popup_logout.scss'

export default function PopupDeleteAccount({ onClose }) {
    const [isVisible, setIsVisible] = useState(true);
    const popupRef = useRef(null);
    const { deleteProfile, signout } = useAuth();
    const navigate = useNavigate();

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    const handleDeleteAccount = async () => {
        setIsVisible(false);
        await deleteProfile();
        await signout();
        navigate('/');
        if (onClose) {
            onClose();
        }

    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (!isVisible) {
        return null;
    }


    return (
        <div className='popup-holder'>
            <div className='popup-body' ref={popupRef}>
                <div className='popup-close-btn-holder'>
                    <button className='popup-close-btn' onClick={handleClose}>X</button>
                </div>
                <h2 className='popup-title'>Are you sure you want to delete your account ?</h2>
                <div className='popup-img-holder'>
                    <img className='popup-img' src={Sadface} alt='sad-face' />
                </div>
                <div className='popup-btn-holder'>
                    <button className='popup-btn' onClick={handleDeleteAccount}>Yes</button>
                    <button className='popup-btn' onClick={handleClose}>No</button>
                </div>
            </div>
        </div>
    )
}